import { zahl } from '../formate';
import type { UnzugeordnetePosition } from '../typen';

/**
 * Positionen, die keinem Lieferanten zugeordnet wurden. Das Ignorieren markenfremder Positionen ist gewollt
 * (ein gemischter Auftrag gilt als bestellt) — die Liste sorgt nur dafuer, dass nichts still verschwindet.
 */
export default function UnzugeordnetTabelle({ positionen }: { positionen: UnzugeordnetePosition[] }) {
  const ohneDaten = positionen.filter((p) => p.grund === 'keine Artikeldaten').length;
  return (
    <section className="space-y-2">
      <h2 className="text-lg font-semibold text-[#1A1A1A]">
        Nicht zugeordnete Positionen{' '}
        <span className="text-sm font-normal text-gray-600">{zahl(positionen.length)}</span>
      </h2>
      {ohneDaten > 0 && (
        <div className="p-3 rounded bg-yellow-50 text-yellow-900 text-sm">
          Für {zahl(ohneDaten)} Position(en) fehlen Artikeldaten — sie konnten keinem Lieferanten zugeordnet werden.
        </div>
      )}
      {positionen.length === 0 ? (
        <p className="text-sm text-gray-500">Alle Positionen sind einem Lieferanten zugeordnet.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm border border-[#DAD9D9]">
            <thead className="bg-[#DAD9D9] text-[#1A1A1A]">
              <tr>
                <th className="px-3 py-2 text-left">Auftrag</th>
                <th className="px-3 py-2 text-right">Variation</th>
                <th className="px-3 py-2 text-left">Name</th>
                <th className="px-3 py-2 text-left">Hersteller</th>
                <th className="px-3 py-2 text-right">Menge</th>
                <th className="px-3 py-2 text-right">Lager</th>
                <th className="px-3 py-2 text-left">Grund</th>
              </tr>
            </thead>
            <tbody>
              {positionen.map((p, i) => (
                <tr key={`${p.orderId}-${p.variationId}-${i}`} className="border-t border-[#DAD9D9]">
                  <td className="px-3 py-2">{p.orderId}</td>
                  <td className="px-3 py-2 text-right">{p.variationId}</td>
                  <td className="px-3 py-2">{p.name || '—'}</td>
                  <td className="px-3 py-2">{p.hersteller || '—'}</td>
                  <td className="px-3 py-2 text-right">{zahl(p.menge)}</td>
                  <td className="px-3 py-2 text-right">{p.warehouseId ?? '—'}</td>
                  <td className="px-3 py-2">
                    <span
                      className={`px-2 py-0.5 rounded text-xs ${
                        p.grund === 'keine Artikeldaten'
                          ? 'bg-yellow-100 text-yellow-900'
                          : 'bg-white text-gray-700 border border-[#DAD9D9]'
                      }`}
                    >
                      {p.grund}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
